export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-toast/index.js